import { ESIGN_PLACEMENT } from "../../../../CheckoutPages/constants/CheckoutPages.constants";
import { ISessions } from "../ISessions";

export const DEFAULT_SESSION_OBJECT: ISessions.ISessionData = {
  listing_uuid: "",
  listing_type: 0,
  listing_title: "",
  listing_mode: "",
  listing_cover_image: "",
  session_start_time: "",
  session_end_time: "",
  session_uuid: "",
  address_type: 0,
  session_number: 0,
  total_sessions: 0,
  recording_link: "",
  venue_details: {
    joining_password: "",
    whatsapp_link: "string",
    contact_number: "string",
  },
  allow_customer_rescheduling: false,
  attendance_status: 0,
  is_attended: false,
  booking_uuid: "",
  allow_customer_scheduling_post_payment: false,
  transaction_uuid: "",
  listing_metadata: {
    esign_placement: ESIGN_PLACEMENT.BEFORE_BOOKING,
    is_esign_enabled: false,
    post_booking_cta_text: "",
    post_booking_url: "",
  },
  order_uuid: "",
  esign_completed: false,
};

export const APPOINTMENT_SCHEDULING_URL_PATH = "/appointment_schedule";
export const SESSION_UUID_SEARCH_PARAM_KEY = "slot_uuid";
